import React from 'react'
import Search from '@material-ui/icons/Search'

export default function SearchIcon({ ...other}) {

    return (
        <Search {...other} />
    )
}